<template>
  <el-button plain v-bind:style="style" class="button-a" :disabled="disabled">
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  components: {},
  props: {
    color: String, // 边框与文字颜色
    bgcolor: {
      // 背景色
      type: String,
      default: "#fff"
    },
    padding: {
      type: String,
      default: "10px 18px"
    },
    disabled: Boolean
  },
  data() {
    return {
      style: {
        padding: this.padding,
        color: this.color,
        borderColor: this.color,
        backgroundColor: this.bgcolor
      }
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.el-button {
  border-radius: 8px;
  padding: 10px 18px;
  opacity: 0.8;
  &:active {
    opacity: 1;
    background-color: rgba(200, 200, 200, 0.1);
  }
}
</style>